/**
 * Frontpage-card registry — Tilleggsmoduler (C): components rendered on the
 * frontpage (routes/frontpage/loggedIn.js) and the Dyrejournal dashboard that
 * belong to products NOT in the Dyrejournal build. Consumers destructure from
 * this map and render as usual — render sites need no guards because the
 * export stub maps EVERY key to a null-rendering component:
 *
 *   const Empty = () => null;
 *   export default new Proxy({}, { get: () => Empty });
 *
 * Classification source of truth: docs/dyrejournal-separation/manifest.md
 */
import InstallationList from '../components/installation/list';
import InspectionList from '../components/inspection/list';
import ArticleList from '../components/article/list';
import ArticleTickerList from '../components/article/listTicker';
import NewsList from '../components/news/list';
import RaceList from '../components/race/list';
import PastRaces from '../components/race/pastRaces';
import LoanList from '../components/part/loanList';
import PartList from '../components/part/list';
import TimeTrackerList from '../components/timetracker/list';
import TimeTrackerActiveTimers from '../components/timetracker/activeTimers';
import Convention from '../components/convention';
import ConventionCompact from '../components/convention/listCompact';
import MarketplaceGrid from '../components/marketplace/grid';
import VideoGrid from '../components/article/videoGrid';
import ArticleFeedMap from '../components/article/feedMap';
import FeedHighlights from '../components/article/feedHighlights';
import ShortsFeed from '../components/shorts/feed';
import ShortsCaptureButton from '../components/shorts/captureButton';
import FFEFrontpage from '../components/ffe/frontpage';
import FFEProducts from '../components/ffe/products';
import PublicCourses from '../components/course/publicCourses';
// onThisDay: NOT part of Dyrejournal (decision 2026-07-05, manifest §9)
import OnThisDayCard from '../components/onThisDay/card';
import WorkSharingListCompact from '../components/workSharing/listCompact';
// Shooting-club «Kom i gang» card (Klubbdrift) — not part of Dyrejournal.
import ClubGettingStarted from '../components/clubOps/gettingStarted';
// Shooting-club advent calendar card («Julekalender») — not part of Dyrejournal.
import AdventCalendarCard from '../components/adventCalendar/card';

export default {
    InstallationList,
    InspectionList,
    ArticleList,
    ArticleTickerList,
    NewsList,
    RaceList,
    PastRaces,
    LoanList,
    PartList,
    TimeTrackerList,
    TimeTrackerActiveTimers,
    Convention,
    ConventionCompact,
    MarketplaceGrid,
    VideoGrid,
    ArticleFeedMap,
    FeedHighlights,
    ShortsFeed,
    ShortsCaptureButton,
    FFEFrontpage,
    FFEProducts,
    PublicCourses,
    OnThisDayCard,
    WorkSharingListCompact,
    ClubGettingStarted,
    AdventCalendarCard,
};
